import Masonry, {ResponsiveMasonry} from 'react-responsive-masonry'
import "./DecoreMasonry.css"

const DecoreMasonry = () => {
  return (
    <div className='masonry_body'>
        <div className='decore_con'>
            <div className='decore_title'>
                <div className='decore_card'>
                    Vår Dekoration
                </div>
            </div>
            <div className='central'>
            <ResponsiveMasonry columnsCountBreakPoints={{350: 1, 750: 2, 900: 3}}>
                <Masonry>
                    <div className='decore_pic'></div>
                    <div className='decore_pic2'></div>
                    <div className='decore_pic3'></div>
                    <div className='decore_pic4'></div>
                    <div className='decore_pic5'></div>
                    <div className='decore_pic6'></div>
                </Masonry>
            </ResponsiveMasonry>
            </div>
        </div>
    </div>
  )
}

export default DecoreMasonry